import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { featureAccessMap, SubscriptionTier } from "utils/accessControlConfig";

export const useAccessControl = () => {
  const { userProfile } = useSelector((state: RootState) => state.applicationData);
  const userDetails = userProfile?.userDetails?.[0];
  const userTier = userDetails?.subscription as SubscriptionTier | undefined;
  const isAdmin = userDetails?.isAdmin === true;

  const hasAccess = (feature: keyof typeof featureAccessMap): boolean => {
    if (isAdmin) return true;
    if (!userTier) return false;
    const allowedTiers = featureAccessMap[feature];
    return allowedTiers.includes(userTier);
  };

  return {
    hasAccess,
    isAdmin,
    userTier,
    canCreateProject: hasAccess("canCreateProject"),
    canAccessRefinedRequirements: hasAccess("canAccessRefinedRequirements"),
    canInviteStakeholders: hasAccess("canInviteStakeholders"),
    canUseBatchProcessing: hasAccess("canUseBatchProcessing"),
    canIdentifyExistingSupplier: hasAccess("canIdentifyExistingSupplier"),
    canSetEvaluationCriteria: hasAccess("canSetEvaluationCriteria"),
    canSetCriticalRequirements: hasAccess("canSetCriticalRequirements"),
    canAssignWeights: hasAccess("canAssignWeights"),
    canDefineBudget: hasAccess("canDefineBudget"),
    canUploadResponses: hasAccess("canUploadResponses"),
    canAccessAdvanceOverviewFeatures: hasAccess("canAccessAdvanceOverviewFeatures"),
    canGenerateRfp: hasAccess("canGenerateRfp"),
    canUploadRfpResponsses: hasAccess("canUploadRfpResponsses"),
    canUploadRfp: hasAccess("canUploadRfp"),
    canDefineProject: hasAccess("canDefineProject"),
    canAssignScore: hasAccess("canAssignScore"),
    canAccessAnalysisAdvanceFeatures: hasAccess("canAccessAnalysisAdvanceFeatures"),
  };
};
